import React from 'react';
import TelegramMiniAppAuth from './TelegramMiniAppAuth';
import { InjectedMarkIcon } from './icons/DashboardIcons';
import { InjectedSyringeCloudLogo } from './icons/InjectedSyringeCloudLogo';
import './CrackerController.css';
import './AuthGate.css';

const LoginPage: React.FC = () => {
  const isTelegramWebApp = !!(
    typeof window !== 'undefined' &&
    (window as any).Telegram?.WebApp?.initData
  );

  if (isTelegramWebApp) {
    return (
      <div className="auth-gate">
        <div className="auth-gate-visual">
          <div className="auth-gate-visual-inner">
            <div className="auth-gate-logo-wrap">
              <InjectedSyringeCloudLogo variant="hero" />
            </div>
            <p className="auth-gate-kicker">Injected Atlas</p>
            <h1 className="auth-gate-title">
              Enter the <em>operator gate</em>
            </h1>
          </div>
        </div>
        <div className="auth-gate-panel-wrap">
          <div className="auth-gate-panel">
            <div className="flex items-center gap-2 mb-6 text-[#e53935]">
              <InjectedMarkIcon size={28} />
              <span className="text-xs font-bold tracking-[0.2em] uppercase text-[#737373]">Telegram</span>
            </div>
            <h2 className="auth-gate-form-title">MiniApp Auth</h2>
            <p className="auth-gate-form-sub">
              Authentification automatique via votre compte Telegram.
            </p>
            <TelegramMiniAppAuth />
          </div>
        </div>
      </div>
    );
  }

  // Hors Telegram — accès refusé, renvoie vers le bot
  return (
    <div className="auth-gate">
      <div className="auth-gate-visual">
        <div className="auth-gate-visual-inner">
          <div className="auth-gate-logo-wrap">
            <InjectedSyringeCloudLogo variant="hero" />
          </div>
          <p className="auth-gate-kicker">Injected Atlas</p>
          <h1 className="auth-gate-title">
            Accès via <em>Telegram uniquement</em>
          </h1>
          <p className="auth-gate-lead">
            Cette interface est exclusivement accessible depuis la Mini-App Telegram.
            Ouvre le bot et lance la Mini-App depuis ton compte.
          </p>
        </div>
      </div>
      <div className="auth-gate-panel-wrap">
        <div className="auth-gate-panel" style={{ textAlign: 'center' }}>
          <div className="flex items-center justify-center gap-2 mb-6 text-[#e53935]">
            <InjectedMarkIcon size={28} />
          </div>
          <h2 className="auth-gate-form-title" style={{ marginBottom: 8 }}>Accès restreint</h2>
          <p className="auth-gate-form-sub" style={{ marginBottom: 28 }}>
            L'accès à l'interface est uniquement disponible via la Mini-App Telegram.
          </p>
          <a
            href="https://t.me/InjectedScannerBot"
            target="_blank"
            rel="noopener noreferrer"
            className="cracker-btn cracker-btn--gold w-full"
            style={{ display: 'block', textAlign: 'center' }}
          >
            📱 Ouvrir le bot Telegram
          </a>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
